import React from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import { Modal, ProgressBar } from 'react-bootstrap';

// STYLES
import styles from './uploadStatus.module.scss';

export default function UploadStatus({ show, percentComplete, onClose }) {
  const inProgress = percentComplete < 100;

  return (
    <Modal
      size="lg"
      aria-labelledby="upload-progress"
      centered
      scrollable
      dialogClassName={styles.dialog}
      backdropClassName="bg-black"
      show={show}
      onHide={onClose}
      backdrop="static"
    >
      <div className="p-3">
        <Modal.Header>
          <div className="text-danger large">
            IMPORTANT! Please do not leave this page or close the browser. You may leave the page when the upload is
            complete.
          </div>
        </Modal.Header>
        <Modal.Body>
          <ProgressBar
            animated={inProgress}
            variant="primary"
            className={clsx(styles.progress, 'rounded-lg')}
            now={percentComplete}
            label={`${percentComplete}%`}
          />
        </Modal.Body>
      </div>
    </Modal>
  );
}
